import { SeriesFilterEnum } from '../../enum/SeriesFilterEnum';
import { UserPreferencesStateProps } from './userPreferencesAtom';

const seriesFilterMigrationMap: Record<number, SeriesFilterEnum> = {
  0: SeriesFilterEnum.TOTAL_CONSUMPTION,
  1: SeriesFilterEnum.DAY_NIGHT,
  2: SeriesFilterEnum.LOCAL_NETWORK_CONSUMPTION,
  3: SeriesFilterEnum.TOTAL_INJECTION,
  4: SeriesFilterEnum.LOCAL_NETWORK_INJECTION,
};

const migrateTypeNumberToEnum = (data: UserPreferencesStateProps): UserPreferencesStateProps => ({
  ...data,
  seriesVisibility: data.seriesVisibility.map((item) => {
    if (typeof item.type !== 'number') {
      return item;
    }

    return {
      ...item,
      type: seriesFilterMigrationMap[item.type] ?? SeriesFilterEnum.TOTAL_CONSUMPTION,
    };
  }),
});

export const migrations: Record<
  number,
  (_data: UserPreferencesStateProps) => UserPreferencesStateProps
> = {
  0: migrateTypeNumberToEnum,
};
